module.exports = __webpack_public_path__ + "static/media/Maf_Curso_01TallerMinisterioPublico.da8bc303.jpg";